module.exports = __webpack_public_path__ + "b042e80e4527185cd64617744f2d223b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/nicole-chung.jpg
// module id = 521
// module chunks = 0